import axios from 'axios'
import { toast } from 'react-toastify'
import { API_URL, BACKEND_URL } from 'utils/apiConstants'

export const updateDiary = async (
  value,
  setLoading,
  id,
  diaryId,
  navigate,
  onBackButtonEvent
) => {
  setLoading(true)

  try {
    const verb = diaryId ? 'put' : 'post'
    const url = diaryId
      ? `${API_URL.diary.updateById}${diaryId}`
      : API_URL.diary.add
    const { data } = await axios[verb](
      BACKEND_URL + url,
      { value },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          id,
        },
      }
    )
    toast.success(data.message, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      closeButton: false,
    })
    setLoading(false)
    // window.removeEventListener('popstate', onBackButtonEvent)
    navigate(-1)
  } catch (err) {
    toast.error(err.message, {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      closeButton: false,
    })
    setLoading(false)
  }
}
